import React,{useState, useEffect} from 'react';
//Components
import ItemDetailOrder from './ItemDetailOrder';
import {Grid} from '@material-ui/core';
//Apis
import {getAllOrderRestaurant} from '../../../../service/ManagerApis';
//Styles
import {MainColors} from '../../Sources/SourcesConst';
import { makeStyles} from '@material-ui/core/styles';

const useStyles = makeStyles(() => ({
    root: {
        width: '100%',
    },
    titleStatus:{
        fontSize: '3vh',
        color: MainColors.secondary,
        textAlign: 'right',
        margin: '0.5vh 1vh 0.5vh 0',
        fontWeight: '450'
    },
    total:{
        color: MainColors.main,
        fontSize: '5vh',
        fontWeight: 350,
        margin: '0',
        textAlign: 'start',
        padding: '0.5vh',
    },
    containerTitle: {
        margin: '0 0 1.5vh 0'
    }
}));

export default function ListDetailOrders(props){

    const classes = useStyles();
    const [listOrders,setListOrders] = useState([]);

    useEffect(() => {
        getAllOrderRestaurant(props.idOrden,array => {
            setListOrders(array);
        });
    },[]);

    const getTotal = () => {
        var total = 0;
        listOrders.forEach(order => {
            total += order.precio;
        });
        return total;
    }

    return(
        <Grid container direction="column" justify="center" alignItems="center">
            <Grid className={classes.containerTitle} item container direction="row" justify="center" alignItems="center">
                <Grid item xs={6}>
                    <p className={classes.titleStatus}>Total</p>
                </Grid>
                <Grid item xs={6}>
                    <p className={classes.total}>{'$' + getTotal()}</p>
                </Grid>
            </Grid>
            {
                listOrders.map((order,index) => (
                    <ItemDetailOrder key={index} dataOrder={order}/>
                ))
            }
        </Grid>
    )
}